function renderDiseases(geneName, pathogenicGenes) {
  if (!geneName || !pathogenicGenes) return null;
  const res = pathogenicGenes.find((info) => info.gene === geneName);
  return res || null;
}

export default renderDiseases;
